import { Directive, Input } from '@angular/core';

@Directive({
    selector: '[appUploadFileAccessibility]',
    standalone: false
})
export class UploadFileAccessibilityDirective {

  @Input() set appUploadFileAccessibility(value) {
    const id = value.replace('Id', '');
    setTimeout(() => {
      const elements = document.getElementById(value).getElementsByTagName('input');
      elements[0].setAttribute('id', id);
    }, 50)
  }
  constructor() { }
}
